import type { ElementType } from 'react'
import { Link, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { COLORS } from '../../../styles/variables'
import { getLegalDocumentPath } from './legalDocumentPaths'
import type { LegalDocumentSlug } from './types'
import { legalParagraphSx } from './style'

const INLINE_LINK_PATTERN = /\[\[(rules|privacy|cookies)\|([^\]]+)\]\]/g

type LegalRichTextProps = {
  text: string
  component?: ElementType
}

export function LegalRichText({ text, component = 'p' }: LegalRichTextProps) {
  const parts: Array<string | { slug: LegalDocumentSlug; label: string }> = []
  let lastIndex = 0
  let match: RegExpExecArray | null

  INLINE_LINK_PATTERN.lastIndex = 0

  while ((match = INLINE_LINK_PATTERN.exec(text)) !== null) {
    const [fullMatch, slug, label] = match
    const matchIndex = match.index

    if (matchIndex > lastIndex) {
      parts.push(text.slice(lastIndex, matchIndex))
    }

    parts.push({ slug: slug as LegalDocumentSlug, label })
    lastIndex = matchIndex + fullMatch.length
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }

  if (parts.length === 0) {
    parts.push(text)
  }

  return (
    <Typography component={component} sx={legalParagraphSx}>
      {parts.map((part, index) => {
        if (typeof part === 'string') {
          return <span key={`${index}-${part}`}>{part}</span>
        }

        return (
          <Link
            key={`${index}-${part.slug}`}
            component={RouterLink}
            to={getLegalDocumentPath(part.slug)}
            underline="hover"
            sx={{ color: COLORS.NICE_BLUE }}
          >
            {part.label}
          </Link>
        )
      })}
    </Typography>
  )
}
